import { ReactNode } from 'react';

interface SectionHeaderProps {
  children: ReactNode;
  description?: string;
  className?: string;
  as?: 'h1' | 'h2' | 'h3';
}

export default function SectionHeader({
  children,
  description,
  className = '',
  as: Component = 'h2',
}: SectionHeaderProps) {
  return (
    <div className={className}>
      <Component className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4 pb-2 border-b border-gray-200 dark:border-gray-700">
        {children}
      </Component>
      {description && (
        <p className="text-sm text-gray-500 dark:text-gray-400 -mt-2 mb-4">
          {description}
        </p>
      )}
    </div>
  );
}
